/*eslint-disable */

import axios from 'axios';
import {bus} from '@/main';
import paperUploadInFolder from '../paper-upload-in-folder';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let savedQuerySearchPaperApiUrl = root.savedQuerySearchPaperApiUrl.link;

export default {
  name: 'save-paper-info',
  components: {
    'paper-upload-in-folder' : paperUploadInFolder
  },
  props: ['paperInfo'],
  data() {
    return {
      isSubmitted: false,
      paperId:'',
      paperSavedInFolderState:false
    }
  },
  computed: {

  },
  mounted() {
    bus.$on('paperSavedInFolderStateBus', (data) => {
      this.paperSavedInFolderState = data
    })
  },
  methods: {
    getPaperPileListAgain() {
      this.$store.dispatch('getAllPaperPileFun')
    },
    savePaperinFolderBeforeSubmitMethod() {
      this.isSubmitted = true
      axios.post(savedQuerySearchPaperApiUrl, this.paperInfo)
        .then((res) => {
          if(res.data.data.result.message){
           toast.success(res.data.data.result.message);
          }else{
            this.paperId = res.data.data.result.id
            toast.success("Request processed successfully.");
            this.paperSavedInFolderState = true
          }
          this.getPaperPileListAgain()
          this.isSubmitted = false
        }).catch((err) => {
          this.isSubmitted = false
          toast.error('Request Failed');
        })
    },
    savePaperBeforeSubmitMethod() {
      this.isSubmitted = true
      axios.post(savedQuerySearchPaperApiUrl, this.paperInfo)
        .then((res) => {
          this.getPaperPileListAgain()
          this.closeAllPopupMethod()
          toast.success(res.data.data.result.message || "Request processed successfully.");
          this.isSubmitted = false
        }).catch((err) => {
          this.isSubmitted = false
          toast.error('Request Failed');
        })
    },
    closeAllPopupMethod(){
      bus.$emit('savePaperPopupStateBus', false);
      bus.$emit('addPaperPilePopupStateBus', false);
      bus.$emit('uploadPaperStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
    closeSavePaperPopupMethod(){
      bus.$emit('savePaperPopupStateBus', false);
    }
  }
}